import { AxiosInstance } from "axios";
import { ErrorTypes, IError } from "../../../interface/IShareInfo";
import { Dispatch } from "redux";
import {
  ISignInPending,
  AuthActionTypes,
  ISignInSuccess,
  ISignInFailed
} from "../SignIn/actions";

import { ISignupPayload } from "./ISignup";
import { errorResponseHandler } from "../../../commons/utils/errorMessagesHandler";

const api_base = "";

export const signUp = (payload: ISignupPayload) => async (
  dispatch: Dispatch,
  getState: any,
  axios: AxiosInstance
) => {
  dispatch<ISignInPending>({
    type: AuthActionTypes.AUTHENTICATE__PENDING
  });

  try {
    let response = await axios.post(`${api_base}/register`, {
      ...payload
    });

    response = await axios.post(`${api_base}/signIn/jwt`, {
      Username: payload.userName,
      Password: payload.password
    });

    const { token_type, access_token } = response.data;
    const newToken = `${token_type} ${access_token}`;
    axios.defaults.headers.common["Authorization"] = newToken;

    dispatch<ISignInSuccess>({
      type: AuthActionTypes.AUTHENTICATE__SUCCESS,
      payload: {
        uid: undefined,
        role: undefined,
        token: newToken
      }
    });
  } catch (error) {
    dispatch<ISignInFailed>({
      type: AuthActionTypes.AUTHENTICATE__FAILED,
      error: errorResponseHandler(error) as IError
    });
    axios.defaults.headers.common["Authorization"] = "";
  }
};
